<template>

  <div id="contacts">
    <h1>Get in touch</h1>
    <p>Drop us a line for questions, feedback and comments on Twitter or via email.</p>
    <br />
    <br />
    <br />
    <ul>
      <li>Email: <a href="mailto:hello@hoopcharts.xyz" target="_blank">hello@hoopcharts.xyz</a></li>
      <li>Twitter: <a href="https://twitter.com/thoomyorke" target="_blank">@thoomyorke</a></li>
    </ul>
    <Footer></Footer>
    </div>
</template>
